import axios from 'axios';
import { handleHttpResponseError } from '@/api/response-error-handler.js';

// ---
// общий обработчик транспортных ошибок и обработчик подкласса ошибок запроса (случаев, когда ответ от сервера не пришел)
//   не зависят от апи, и теоретически могут быть унифицированы для разных проектов
// ---

function handleHttpRequestError (error) {
  if (!navigator.onLine) {
    throw new Error('Отсутствует подключение к Интернет');
  }
  
  //  можно обработать разные классы ошибок Axios: разделить ошибки связи и иные
  //  см. https://axios.rest/pages/advanced/error-handling
  //  не зависит от апи, можно пробовать стандартизировать
  // также можно тут подключить перевод на неанглийский язык
  throw error;
}

export function handleTransportError (error) {
  if (!axios.isAxiosError(error)) 
    throw error;

  if (error.response) {
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    handleHttpResponseError(error);
  } 
  else {
    handleHttpRequestError(error);
  }
}
